module.exports = __webpack_public_path__ + "static/media/morning-snack1-1.1efa974a.jpg";